module.exports = __webpack_public_path__ + "static/media/frizo-affiliate-inessa-mendoza.81dff329.jpg";